var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.noData)?_c('div',{staticClass:"noDataText"},[_c('h4',[_vm._v("Não há termos pendentes.")])]):_vm._e(),_c('div',[_c('ModalAssinaturaTermo',{attrs:{"assinaturaTermo":_vm.assinaturaTermo},on:{"resposta":_vm.respostaModalAssinatura}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }